import { screen } from 'components/styles/variables';

export default function Image({ src }: { src: string }): JSX.Element {
  return (
    <>
      <img src={src} alt="Map" className="map" />
      <style jsx>
        {`
          .map {
            width: 100%;
            height: auto;
            object-fit: cover;
          }

          @media screen and (min-width: ${screen.smMin}) {
            .map {
              height: 177px;
            }
          }
        `}
      </style>
    </>
  );
}
